import {
  Component,
  computed,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ReportsUtilsService } from '@app/modules/reports/services/reports-utils.service';
import { ReportsState } from '@app/modules/reports/store/reports.state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableActionsLocation,
  DataTableActionType,
  DataTableConfiguration,
  DataTableDataType,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';

@Component({
  selector: 'app-connected-reports-list',
  imports: [DataTableComponent, TranslatePipe],
  templateUrl: './reports-overview.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reports-overview.component.scss',
})
export class ReportsOverviewComponent {
  private store = inject(Store);
  private reportUtils = inject(ReportsUtilsService);
  private modal = inject(NgbActiveModal);

  public reportIds = signal<string[]>([]);

  reports = computed(() =>
    this.store.selectSignal(ReportsState.getReportsByIds)()(this.reportIds())
  );

  dataTableConfiguration: DataTableConfiguration = {
    title: '',
    selectionMode: DataTableSelectionType.NONE,
    actionsLocation: DataTableActionsLocation.RIGHT,
    singleActions: [
      {
        name: 'Open report',
        icon: 'fa-light fa-file',
        action: (event, report) =>
          this.reportUtils.openReportDetailsDialog(report.id),
        type: DataTableActionType.BUTTON,
        permission: 'reports.reportsList.buttons.view',
      },
    ],
    columns: [
      {
        label: 'reports.list.columns.kitId',
        invoke: {
          objectReference: {
            fn: (report: any) =>
              report.properties?.find((p) => p.key === 'KitId')?.value,
          },
          name: 'fn',
          args: [],
        },
      },
      {
        label: 'reports.list.columns.analysisType',
        invoke: {
          objectReference: {
            fn: (report: any) =>
              report.properties?.find((p) => p.key === 'AnalysisType')?.value,
          },
          name: 'fn',
          args: [],
        },
      },
      {
        label: 'reports.list.columns.version',
        invoke: {
          objectReference: {
            fn: (report: any) => 'v' + report.version,
          },
          name: 'fn',
          args: [],
        },
      },
      {
        label: 'reports.list.columns.reportType',
        property: 'reportType',
      },
      {
        label: 'reports.list.columns.reportReason',
        property: 'reportReason',
      },
      {
        label: 'reports.list.columns.generated',
        property: 'generated',
        type: DataTableDataType.DATETIME,
      },
      {
        label: 'reports.list.columns.status',
        property: 'status',
      },
    ],
    rows$: toObservable(this.reports),
  };

  dismiss() {
    this.modal.dismiss();
  }
}
